<div class="container-fluid login-modal col-md-12">
  <div class="row">
    <div class="offset-11 col-1">
      <button (click)="close()" class="btn-close pull-right"></button>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <h4>Login</h4>
    </div>
  </div>
  @if (ssoRefusal) {
    <div class="row">
      <div class="col">
        <label class="error-red">{{ ssoRefusal }}</label>
      </div>
    </div>
  } @else if (isLoginError) {
    <div class="row">
      <div class="col">
        <label class="error-red"
          >The email and/or password you entered did not match our records.
          Please double-check and try again.</label
        >
      </div>
    </div>
  }
  <div class="row row-padding-bottom">
    <div class="col">
      <div class="row">
        <div class="col">
          <label>Email:</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <input
            class="form-control"
            type="text"
            [formControl]="$any(loginModalForm.controls['email'])"
            (blur)="ssoLogin.discover()"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row row-padding-bottom">
    <div class="col">
      <div class="row">
        <div class="col">
          <label>Password:</label>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <app-password-field
            [passwordFormControl]="$any(loginModalForm.controls['password'])"
          ></app-password-field>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-auto">
      <a href="javascript:void(0)" (click)="forgotPassword()"
        >Forgot Password?</a
      >
    </div>
  </div>

  <div class="row row-padding">
    <div class="col">
      <button class="btn btn-lg btn-primary btn-block" (click)="login()">
        LOGIN
      </button>
      <app-sso-login-button
        #ssoLogin
        [emailControl]="loginModalForm.controls['email']"
        [enabled]="offerSso"
      ></app-sso-login-button>
    </div>
  </div>
</div>
